import L from 'leaflet';

let Control = {
  options: {
    position: 'topright',
    className: 'my-custom-control',
  },
  initialize(options) {
    L.Util.setOptions(this, options);
  },
  onAdd() {
    // create the control div with a particular class name
    const { className } = this.options;
    const div = L.DomUtil.create('div', className);
    L.DomEvent.disableClickPropagation(div);
    L.DomEvent.disableScrollPropagation(div);

    return div;
  },
  addTo(map) {
    this._map = map;

    let container = (this._container = this.onAdd(map)),
      pos = this.getPosition(),
      corner = map._controlCorners[pos];

    L.DomUtil.addClass(container, 'leaflet-control');

    const insertNormally = () => {
      if (pos.indexOf('bottom') !== -1) {
        corner.insertBefore(container, corner.firstChild);
      } else {
        corner.appendChild(container);
      }
    };

    const { order } = this.options;

    if (typeof order !== 'undefined') {
      // Insert he control at the designated order in child nodes
      if (corner.childNodes[order]) {
        corner.insertBefore(container, corner.childNodes[order]);
      } else {
        insertNormally();
      }
    } else {
      insertNormally();
    }

    return this;
  },
};

export function control(options) {
  let NewControl = L.Control.extend(Control);
  return new NewControl(options);
}

export default control;
